import AdviserDataDumpApi from '../../core/api/AdviserDataDumpApi'

export const ADVISER_DATA_DUMP_DOWNLOADING = 'ADVISER_DATA_DUMP_DOWNLOADING'
export const ADVISER_DATA_DUMP_DOWNLOAD_COMPLETE = 'ADVISER_DATA_DUMP_DOWNLOAD_COMPLETE'

export const downloadingAdviserDataDump = () => ({
  type: ADVISER_DATA_DUMP_DOWNLOADING
})

export function downloadCurrentData () {
  const api = new AdviserDataDumpApi()
  const request = api.download()

  return (dispatch) => {
    dispatch(downloadingAdviserDataDump())
    request.then(function (response) {
      const now = new Date()
      const fileName = `Data Dump - ${now.toDateString()}.xlsx`
      api.handleFileResponse(response, fileName)
        .then(function () {
          dispatch(api.handleResponse(ADVISER_DATA_DUMP_DOWNLOAD_COMPLETE, response))
        })
    })
  }
}
